import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslate } from 'react-admin';

export type EmptyScreenProps = { svg?: ReactNode; label?: string; button?: ReactNode };

export const EmptyScreen = (props: EmptyScreenProps) => {
  const translate = useTranslate();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100%',
        paddingBottom: '15px',
      }}>
      <>
        {props.svg}
        {props.label && <Typography>{translate(props.label)}</Typography>}
        {props.button}
      </>
    </Box>
  );
};
